module.exports = {"Save":"Зберегти","chart.rowExceed":"Records count must be 500 and less","chart.selectTop":"Select top","chart.fetchingIds":"Selection finish...","search.hintText":"Введіть для пошуку (* для всіх)","shipment.packagingSender":"Відправник","Supplier":"Постачальник"}


//////////////////
// WEBPACK FOOTER
// ./src/core/common/locales/uk.json
// module id = 1356
// module chunks = 1